import { Box, Skeleton } from "@mui/material";
import Lottie from "lottie-light-react";
import type { FC } from "react";
import star from "./star.json";

export const ImageLoading: FC = () => {
  return (
    <>
      <Skeleton
        sx={{ width: "100%", height: "100%" }}
        data-testid="skeleton"
        variant="rectangular"
      />
      <Box
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "16px",
        }}
      >
        <Box style={{ height: "32px", width: "32px" }}>
          <Lottie animationData={star} loop autoPlay />
        </Box>
        Loading
      </Box>
    </>
  );
};
